import { Group } from '@mantine/core';

import { BadgeIcons } from '~/components/shared/Badges/Badges';
import { Title } from '~/domains/design-system/Title';
import type { Contest } from '~/domains/contest/domains/services/interfaces/contest.interface';
import ContestTypeBadge from '~/domains/contest/domains/common/components/ContestTypeBadge/ContestTypeBadge';

function ContestTagsColumn({ contest }: { contest: Contest }) {
  return (
    <Group /* eslint-disable-line local-rules/use-theme-tokens */ spacing={8} noWrap>
      <BadgeIcons wrapStyle="" tags={contest.tags} iconSize={20} />
      <Title variant="title-small">
        <ContestTypeBadge
          type={contest.contest_type}
          altLabel={contest.contest_type_alt_text}
          variant="text"
        />
      </Title>
    </Group>
  );
}

export default ContestTagsColumn;
